module.exports = __webpack_public_path__ + "static/media/google.9d3575ef.svg";